import React from 'react';
import { css } from '@emotion/core';
import PropTypes from 'prop-types';
import gameResultsAttributesType from '../proptypes/game-results-attributes';
import phrasesType from '../proptypes/phrases';
import selectScoreCardEncryption from '../selectors/score-card-encryption';
import selectScoreCardSpecialOps from '../selectors/score-card-special-ops';
import selectScoreCardSurveillance from '../selectors/score-card-surveillance';
import selectScoreCardDeception from '../selectors/score-card-deception';
import selectScoreCardMentalHorsepower from '../selectors/score-card-mental-horsepower';
import selectScoreCardPsychometrics from '../selectors/score-card-psychometrics';
import ScoreCardEncryption from './ScoreCardEncryption';
import ScoreCardDeception from './ScoreCardDeception';
import ScoreCardSurveillance from './ScoreCardSurveillance';
import ScoreCardSpecialOps from './ScoreCardSpecialOps';
import ScoreCardOnlineGame from './ScoreCardOnlineGame';
import { mediaBreakpointUpMD, mediaBreakpointUpLG } from '../constants/style-constants';
import { selectScoreCardHotRiskNegative, selectScoreCardHotRiskPositive } from '../selectors/score-card-hot-risk-2';

const ScoreCards = ({
  attributes,
  attributesPath,
  phrases,
  specialOpsVideoUrl,
  specialOpsVideoPagePath,
  remainingChallenges,
}) => {
  const specialOpsScoreCardData = selectScoreCardSpecialOps(
    attributes,
    phrases,
    specialOpsVideoUrl,
    specialOpsVideoPagePath,
  );
  const encryptionScoreCardData = selectScoreCardEncryption(
    attributes,
    phrases,
  );
  const surveillanceScoreCardData = selectScoreCardSurveillance(
    attributes,
    phrases,
  );
  const deceptionScoreCardData = selectScoreCardDeception(attributes, phrases);
  const mentalHorsepowerScoreCardData = selectScoreCardMentalHorsepower(
    attributes,
    phrases,
    remainingChallenges,
  );
  const hotRiskPositiveScoreCardData = selectScoreCardHotRiskPositive(
    attributes,
    phrases,
    remainingChallenges,
  );
  const hotRiskNegativeScoreCardData = selectScoreCardHotRiskNegative(
    attributes,
    phrases,
    remainingChallenges,
  );
  const psychometricsScoreCardData = selectScoreCardPsychometrics(
    attributes,
    phrases,
    remainingChallenges,
    attributesPath,
  );

  return (
    <div
      className="card-columns"
      css={css`
        column-count: 1;

        ${mediaBreakpointUpMD} {
          column-count: 2;
          column-gap: 2rem;
        }

        ${mediaBreakpointUpLG} {
          column-count: 3 !important; /* stylelint-disable-line declaration-no-important */
        }`
      }
    >
      {specialOpsScoreCardData && (
        <ScoreCardSpecialOps {...specialOpsScoreCardData} />
      )}
      {surveillanceScoreCardData && (
        <ScoreCardSurveillance {...surveillanceScoreCardData} />
      )}
      {deceptionScoreCardData && (
        <ScoreCardDeception {...deceptionScoreCardData} />
      )}
      {hotRiskPositiveScoreCardData && (
        <ScoreCardOnlineGame showCommentary {...hotRiskPositiveScoreCardData} />
      )}
      {hotRiskNegativeScoreCardData && (
        <ScoreCardOnlineGame showCommentary {...hotRiskNegativeScoreCardData} />
      )}
      {encryptionScoreCardData && (
        <ScoreCardEncryption {...encryptionScoreCardData} />
      )}
      {psychometricsScoreCardData && (
        <ScoreCardOnlineGame {...psychometricsScoreCardData} />
      )}
      {mentalHorsepowerScoreCardData && (
        <ScoreCardOnlineGame {...mentalHorsepowerScoreCardData} />
      )}

    </div>
  );
};

ScoreCards.propTypes = {
  attributes: gameResultsAttributesType.isRequired,
  phrases: phrasesType.isRequired,
  attributesPath: PropTypes.string.isRequired,
  specialOpsVideoUrl: PropTypes.string.isRequired,
  specialOpsVideoPagePath: PropTypes.string.isRequired,
  remainingChallenges: PropTypes.arrayOf(
    PropTypes.shape({
      path: PropTypes.string.isRequired,
      application: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default ScoreCards;
